import React, { useMemo, useState } from "react";
import { CORRECTIVE_ACTIONS } from "./panicConfig";

export default function PanicCorrectiveActionModal({ step, onClose, onSave, saving }) {
  const config = CORRECTIVE_ACTIONS[step?.correctiveType] || CORRECTIVE_ACTIONS.generica;
  const [problem, setProblem] = useState(config.problemOptions[0] || "");
  const [action, setAction] = useState(config.actionOptions[0] || "");
  const [note, setNote] = useState("");
  const [verification, setVerification] = useState(config.verification || "");

  const payload = useMemo(() => ({
    problem,
    action,
    note,
    verification,
    timestamp: new Date().toISOString(),
  }), [problem, action, note, verification]);

  if (!step) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4">
      <div className="w-full max-w-xl rounded-2xl bg-white p-5 shadow-xl">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-red-600">Azione correttiva</div>
            <h2 className="mt-1 text-xl font-bold text-slate-950">{step.title}</h2>
            <p className="mt-1 text-sm text-slate-600">
              Meglio una correzione tracciata che una risposta improvvisata.
            </p>
          </div>
          <button type="button" onClick={onClose} className="rounded-xl border px-3 py-2 text-sm hover:bg-slate-50">
            Chiudi
          </button>
        </div>

        <div className="mt-5 space-y-4">
          <label className="block">
            <span className="text-xs font-semibold text-slate-500">Problema rilevato</span>
            <select className="mt-1 w-full rounded-xl border px-3 py-2" value={problem} onChange={(e) => setProblem(e.target.value)}>
              {config.problemOptions.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
          </label>

          <label className="block">
            <span className="text-xs font-semibold text-slate-500">Azione immediata</span>
            <select className="mt-1 w-full rounded-xl border px-3 py-2" value={action} onChange={(e) => setAction(e.target.value)}>
              {config.actionOptions.map((item) => <option key={item} value={item}>{item}</option>)}
            </select>
          </label>

          <label className="block">
            <span className="text-xs font-semibold text-slate-500">Nota / prova</span>
            <textarea
              className="mt-1 min-h-[90px] w-full rounded-xl border px-3 py-2"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Scrivi solo cio che e verificabile."
            />
          </label>

          <label className="block">
            <span className="text-xs font-semibold text-slate-500">Verifica successiva</span>
            <input
              className="mt-1 w-full rounded-xl border px-3 py-2"
              value={verification}
              onChange={(e) => setVerification(e.target.value)}
            />
          </label>
        </div>

        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-xl border px-4 py-2 text-sm hover:bg-slate-50">
            Annulla
          </button>
          <button
            type="button"
            disabled={saving}
            onClick={() => onSave(payload)}
            className="rounded-xl bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-60"
          >
            {saving ? "Salvo..." : "Registra NON OK"}
          </button>
        </div>
      </div>
    </div>
  );
}
